<template>
  <el-select :size="size"
             v-model="currentValue"
             :multiple="multiple"
             :collapse-tags="collapseTags"
             :filterable="filterable"
             :disabled="disabled"
             :clearable="clearable"
             @change="change($event)" :class="{'width100': width100}">
    <el-option v-for="item in innerDictionary.items" :key="item[innerDictionary.valueKey]"
               :value="item[innerDictionary.valueKey]" :label="item[innerDictionary.textKey]"
    ></el-option>
  </el-select>
</template>

<script>
  import { getChildren } from "@/service/region.service";
  import { Dictionary } from '@/util/common/dictionary';
  export default {
    name: "ProvinceSelect",
    props: {
      size: {},
      value: {},
      multiple: {},
      collapseTags: {},
      filterable: {},
      disabled: {},
      clearable: {},
      width100: {
        type: Boolean,
        default: true,
      },

      parentRegion: {
        type: Object,
        default: () => ({
        })
      },
    },
    data() {
      return {
        currentValue: null,
        innerDictionary: new Dictionary()
      };
    },
    watch: {
      value: {
        deep: true,
        immediate: true,
        handler(value) {
          this.currentValue = value;
        }
      },
      parentRegion: {
        deep: true,
        immediate: true,
        handler(value) {
          this.load(value);
        }
      }
    },
    methods: {
      load(value) {
        if (value != null) {
          getChildren(value.code, value.name).then(children => {
            this.innerDictionary = new Dictionary({items: children, valueKey: 'name', textKey: 'name'});
            this.$emit('loaded', this.innerDictionary);
          });
        }
      },
      change(event) {
        this.$emit('input', event);
        this.$emit('change', [event, this.innerDictionary.getItem(event)]);
      },
    },
    created() {
      this.load();
    }
  }
</script>

<style scoped>

</style>
